import { createFileRoute } from '@tanstack/react-router';
import { CourseDetailPage } from '@/pages/courses/CourseDetailPage';

export const Route = createFileRoute('/_authenticated/_app/courses/$courseId')({
	component: CourseDetailPage,
});
